// test2650
(2650 && 0);
